import { render, staticRenderFns } from "./DocumentSidebar.vue?vue&type=template&id=4db360bf&scoped=true"
import script from "./DocumentSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocumentSidebar.vue?vue&type=style&index=0&id=4db360bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db360bf",
  null
  
)

export default component.exports